import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { Variavel } from '../models/variavel';

@Injectable({
  providedIn: 'root'
})
export class VariaveisService {

  constructor(private http: HttpClient) {

  }

  consultarVariaveis() {
    return this.http.get<Variavel[]>(globals.apiUrl + '/api/Variaveis/Lista');
  }
}
